import { render } from "./Profile.vue?vue&type=template&id=96c95408&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=96c95408&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-96c95408"

export default script